import LogoRed from "./appLogoRed.png";
import LogoWhite from "./logo_white.svg";
import LogoBlack from "./appLogoWhatsBanned.png";
import emptyImage from "./emptyImage.png";
// import svg from "../../Assets/svg";

export const allCommonImages = {
	LogoWhite,
	LogoBlack,
	emptyImage,
	LogoRed: LogoRed,

	// LogoBlack: svg.appLogo,
	// LogoWhite: svg.appLog,
};
